import { Dropdown } from "primereact/dropdown";
import React from "react";
import { IForm } from "../models/Form.model";

interface SharedDropdownProps {
  item: IForm;
  handleFormData: any;
}

export default function SharedDropdown({
  item,
  handleFormData,
}: SharedDropdownProps) {
  return (
    <div className="form-group">
      <label>{item.label}</label>
      <Dropdown
        value={item.value}
        onChange={(e) => handleFormData(e.value)}
        options={item.options || []}
        placeholder="Select"
        disabled={item.isDisabled}
      />
    </div>
  );
}
